
import Vue from "vue";
import Menu from "@/components/common/Menu.vue";
import SearchJobForm from "@/components/Home/SearchJobForm.vue";
import BrowseJobByCategory from "@/components/Home/BrowseJobByCategory.vue";
import Counter from "@/components/Home/Counter.vue";
import Footer from "@/components/common/Footer.vue";

export default Vue.extend({
  name: "Home",

  components: {
    Footer,
    Counter,
    BrowseJobByCategory,
    SearchJobForm,
    Menu,
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      errorSnackBarMessage: "",
      displayErrorSnackBar: false,
      displayErrorSnackBarTimeout: 5000,
      displayMenu: false,
    };
  },

  methods: {
    displayErrorSnack(message: string): void {
      this.errorSnackBarMessage = message;
      this.displayErrorSnackBar = true;
    },
  },

  mounted() {
    const currentUser = localStorage.getItem("currentUser");
    this.displayMenu = currentUser === null;
  },
});
